import * as React from 'react'
import { FC, PropsWithChildren } from 'react'
import { cls } from '../../utils/utils'
import { TextColors } from '../../utils/constants'
import { Parallelepiped } from '../Parallelepiped/Parallelepiped'
import ReadyToTalk from './components/ReadyToTalk/ReadyToTalk'
import styles from './Section.module.scss'
import { ISectionProps } from './Section.types'
import { parallelepipedColors } from './Section.constants'

const Section: FC<PropsWithChildren<ISectionProps>> = (props) => {
  const style = {
    backgroundImage: `url(${props.background?.image?.publicURL})`,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: props.background?.positionX,
    backgroundPositionY: props.background?.positionY,
  }

  const pdColor = props.parallelepipedColor || 'white'

  return (
    <section
      {...[props.anchor && { id: props.anchor }]}
      style={props.background ? style : {}}
      className={cls(
        styles[`${props.backgroundColor || 'white'}Section`],
        props.hideBottomPadding ? styles.dontShowPadding : styles.showUpperPadding,
        styles.section
      )}
    >
      {!props.dontShowParallelepiped && (
        <Parallelepiped color={parallelepipedColors[pdColor]} classname={cls(props.shiftParallelepiped && styles.shiftParallelepiped)} />
      )}
      <div className="main-container">
        <div
          className={cls(
            styles.content,
            !props.hideBottomPadding && styles.showLowerPadding,
            !props.hideBottomPadding && !props.hidePaddingForReady && styles.showLowerPadding,
            props.smallBottomPadding && styles.smallBottomPadding
          )}
        >
          {props.children}
        </div>
        {props.readyToTalkText && (
          <ReadyToTalk
            colorTitle={props.backgroundColor === 'dark' ? TextColors.WHITE : TextColors.DARK}
            readyToTalkText={props.readyToTalkText}
            buttonText={props.buttonText}
            buttonLink={props.buttonLink}
            dialog={props.dialog}
            shiftBottom={props.shiftBottom}
            shiftBottomMobile={props.shiftBottomMobile}
          />
        )}
      </div>
    </section>
  )
}

export default Section
